import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDutySource implements BaseEnumType {
  private static allValues: EnumDutySource[] = []; // make sure this is top-most
  
  public static none = new EnumDutySource(0, "None", "enum_duty_source_none");
  public static order = new EnumDutySource(1, "Order", "enum_duty_source_order");
  public static credit = new EnumDutySource(2, "Credit", "enum_duty_source_credit");
  public static stockAudit = new EnumDutySource(3, "StockAudit", "enum_duty_source_stock_audit");
  public static stockTransferOut = new EnumDutySource(4, "StockTransferOut", "enum_duty_source_stock_transfer_out");
  public static purchaseOrder = new EnumDutySource(5, "PurchaseOrder", "enum_duty_source_purchase_order");
  public static stockTransferIn = new EnumDutySource(6, "StockTransferIn", "enum_duty_source_stock_transfer_in");
  public static ingredientUsed = new EnumDutySource(7, "IngredientUsed", "enum_duty_source_ingredient_used");
  public static assemblyOutput = new EnumDutySource(8, "AssemblyOutput", "enum_duty_source_assembly_output");
  public static stockTake = new EnumDutySource(9, "StockTake", "enum_duty_source_stock_take");
  public static processOutput = new EnumDutySource(10, "ProcessOutput", "enum_duty_source_process_output");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDutySource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDutySource.none; }
  public isOrder() { return this === EnumDutySource.order; }
  public isCredit() { return this === EnumDutySource.credit; }
  public isStockAudit() { return this === EnumDutySource.stockAudit; }
  public isStockTransferOut() { return this === EnumDutySource.stockTransferOut; }
  public isPurchaseOrder() { return this === EnumDutySource.purchaseOrder; }
  public isStockTransferIn() { return this === EnumDutySource.stockTransferIn; }
  public isIngredientUsed() { return this === EnumDutySource.ingredientUsed; }
  public isAssemblyOutput() { return this === EnumDutySource.assemblyOutput; }
  public isStockTake() { return this === EnumDutySource.stockTake; }
  public isProcessOutput() { return this === EnumDutySource.processOutput; }

  public static getValues(): readonly EnumDutySource[] {
    return EnumDutySource.allValues;
  }

  public static getValuesExcept0(): readonly EnumDutySource[] {
    return EnumDutySource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDutySource {
    const found = EnumDutySource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDutySource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDutySource): EnumDutySource {
    const found = name ? EnumDutySource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDutySource - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDutySource>): boolean {
    return this.key === other?.key;
  }
}